module.exports = __webpack_public_path__ + "static/media/yt(1).32169196.png";